"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stakingPool = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const util_1 = require("@polkadot/api-derive/util");
function getConstants(api) {
    return {
        defaultExchangeRate: api.consts.stakingPool.defaultExchangeRate,
        bondingDuration: api.consts.polkadotBridge.bondingDuration,
        eraLength: api.consts.polkadotBridge.eraLength,
        stakingCurrency: api.consts.stakingPool.stakingCurrencyId,
        liquidCurrency: api.consts.stakingPool.liquidCurrencyId
    };
}
/**
 * @name stakingPool
 * @description get staking pool information
 */
function stakingPool(instanceId, api) {
    return (0, util_1.memo)(instanceId, () => {
        const constants = getConstants(api);
        return (0, rxjs_1.combineLatest)([
            api.query.stakingPool.currentEra(),
            api.query.stakingPool.stakingPoolLedger(),
            api.query.stakingPool.stakingPoolParams(),
            api.query.tokens.totalIssuance(constants.liquidCurrency)
        ]).pipe((0, operators_1.map)((result) => {
            const [currentEra, ledger, params, liquidIssuance] = result;
            return {
                currentEra,
                ledger,
                params,
                liquidIssuance,
                ...constants
            };
        }));
    });
}
exports.stakingPool = stakingPool;
